import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { cn } from '../../lib/utils';

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-canvas">
      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileOpen}
        onToggle={() => setSidebarCollapsed((prev) => !prev)}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar
        sidebarCollapsed={sidebarCollapsed}
        onMobileMenuOpen={() => setMobileOpen(true)}
      />
      <main
        className={cn(
          'pt-[72px] transition-all duration-300',
          // Desktop: respect sidebar width
          sidebarCollapsed ? 'md:ml-16' : 'md:ml-64',
          // Mobile: no margin (sidebar is overlay)
          'ml-0'
        )}
      >
        <div className="p-3 md:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
